import React from 'react';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import MenuTitle from 'components/MenuTitle';
import ActionBarWrapper from 'components/wrappers/pages/ActionBarWrapper';
import LineNavbar from 'components/LineNavbar';
import includes from 'lodash/includes';
import DropdownButtonSelectIcon from 'components/Fields/ReduxForm/DropdownButtonSelectIcon';
import * as clevertapOpenPlatformComponent from 'clevertap/openPlatform/component';
import styles from './ActionBar.css';

const APP_MARKETPLACE_LABEL = 'App Marketplace';
const MY_APPS_LABEL = 'My Apps';
class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <MenuTitle menuTitle="Apps" />
        <div
          className="pull-right col-sm-3"
          style={{
            marginTop: '30px',
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          {this._show('keyword') && (
            <Field
              name="keyword"
              component={SearchBar}
              onChange={this._onChangeKeyword}
              placeholder="Search All Apps"
              id="open-platform-action-bar__search"
            />
          )}
        </div>
        <ActionBarWrapper>
          <div className="row">
            <div className="col-xs-12">
              <LineNavbar
                links={[
                  {
                    href: '/apps/app-market',
                    label: APP_MARKETPLACE_LABEL,
                  },
                  {
                    href: '/apps/my-app',
                    label: MY_APPS_LABEL,
                  },
                ]}
                pathname={this.props.location.pathname}
                forceHighlight={this.props.forceHighlight}
                onClickLink={this._onClickLink}
              />
            </div>
          </div>
          {this._show('category') && (
            <div className={`row ${styles.bottomNavbarWrapper}`}>
              <div className="col-xs-12">
                <Field
                  component={DropdownButtonSelectIcon}
                  name="category"
                  options={this.props.categoryOptions}
                  onChange={this._onChangeCategory}
                />
              </div>
            </div>
          )}
        </ActionBarWrapper>
      </div>
    );
  }

  _onClickLink = ({ link }) => {
    if (link.label === APP_MARKETPLACE_LABEL) {
      clevertapOpenPlatformComponent.appMarketStart();
    } else if (link.label === MY_APPS_LABEL) {
      clevertapOpenPlatformComponent.myAppStart();
    }
  };

  _onChangeKeyword = (e, keyword) => {
    this.props.onChangeField({ field: 'keyword', value: keyword });
  };

  _onChangeCategory = (e, category) => {
    this.props.onChangeField({ field: 'category', value: category });
  };

  _show = fieldname => includes(this.props.fields, fieldname);
}

ActionBar.propTypes = {
  location: PropTypes.object,
  onChangeField: PropTypes.func,
  // list of shown fields
  // can be 'keyword', 'category'
  fields: PropTypes.array,
  categoryOptions: PropTypes.array,
};

ActionBar.defaultProps = {
  fields: [],
};

export default reduxForm({ form: 'search' })(ActionBar);
